/**
 * Validate a raw tenant string against the lower-kebab-case tenant convention and
 * return it, or return `null` (fail-closed) if it is not already a valid label.
 *
 * The single rule is "must already be a valid lower-kebab-case label": lowercase
 * `[a-z0-9-]`, first char alphanumeric (a leading dash is rejected to avoid the odd
 * `de.-foo.json` context), max 32 chars. This is a validate-and-reject guard, NOT a
 * transform: stripping an unsafe value (e.g. `../secret` → `secret`) would silently
 * load a different real tenant's overrides, so anything not already valid falls back
 * to base `de`. The same rule names the override files (`de.<tenant>.json`).
 */
export function sanitizeTenant(raw: string | undefined): string | null {
    // Guard non-strings (the injected global may be undefined) — .toLowerCase()/regex
    // on undefined would throw.
    if (typeof raw !== 'string') {
        return null;
    }

    const candidate = raw.toLowerCase();

    return /^[a-z0-9][a-z0-9-]{0,31}$/.test(candidate) ? candidate : null;
}
